<template>
  <ValidationObserver ref="form" tag="div">
    <b-form class="form--auth"
            @submit.prevent
            v-stream:submit="onLogin$"
            >
      <template>
        <h3>{{ roleName }}登入</h3>
        <transition name="fade">
          <NotificationMessage v-if="error" customStyle="padding:  15px 12px;"
          >登入失敗 : <span>{{error}}</span>
          </NotificationMessage>
        </transition>
        <AGCInput v-model="username"
                  name="帳戶名稱"
                  rules="required"
                  placeholder="帳戶名稱"
                  required
                  @input="clearError"
        ></AGCInput>
        <AGCInput v-model="password"
                  vid="password"
                  name="密碼"
                  type="password"
                  rules="required"
                  class="mb-3"
                  placeholder="密碼"
                  required
                  @input="clearError"
        ></AGCInput>
        <div class="d-flex align-items-baseline justify-content-between mb-4">
          <b-form-checkbox class="form__remember">記住我</b-form-checkbox>
          <router-link v-if="role === 'merchant'"
                       to="/forgetPassword"
                       class="form__forget-pw"
          >
            忘記密碼？
          </router-link>
        </div>
        <b-button type="submit"
                  variant="primary"
                  size="lg"
                  :disabled="loading"
                  block
        >
          登入
        </b-button>
        <div v-if="role === 'merchant'" class="d-flex justify-content-center mt-3">
          <a href="https://www.ulifestyle.com.hk/merchantcenter/tnc" target="_blank" style="color: #707477;">條款及細則</a>
        </div>
      </template>
      <div v-if="loading" class="form__overlay">
        <LoadingSpinner></LoadingSpinner>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import { tap, switchMap } from 'rxjs/operators';
import {
  BForm,
  BFormCheckbox,
  BButton,
} from 'bootstrap-vue';
import http from '../../helpers/http';
import { getErrorMsg } from '../../helpers/error-msg';
import { SET_USER } from '../../store';
import formMixin from '../../mixins/form';
import AGCInput from '../../components/form/AGCInput.vue';
import LoadingSpinner from '../../components/LoadingSpinner.vue';
import NotificationMessage from '../../components/NotificationMessage.vue';

const ERRORS = {
  UNAUTHORIZED: '請確定輸入正確帳戶名稱及密碼',
};

export default {
  mixins: [formMixin],
  components: {
    BForm,
    BFormCheckbox,
    BButton,
    LoadingSpinner,
    AGCInput,
    NotificationMessage,
  },
  data: () => ({
    username: null,
    password: null,
    loading: false,
    error: null,
  }),
  methods: {
    clearError() {
      this.error = null;
    },
  },
  computed: {
    role() {
      return this.$route.meta.role;
    },
    roleName() {
      if (this.$route.meta.role === 'admin') return '管理員';
      if (this.$route.meta.role === 'sale') return '營銷部';
      return '商戶';
    },
  },
  domStreams: ['onLogin$'],
  subscriptions() {
    return {
      login: this.onLogin$
        .pipe(
          switchMap(this.validate),
          tap(() => {
            this.loading = true;
          }),
          switchMap(() => http({
            method: 'POST',
            url: `/agc-${this.role}-api/auth/login`,
            data: {
              username: this.username,
              password: this.password,
            },
          }, {
            next: (user) => {
              this.$store.commit(SET_USER, user);
              this.$router.replace({
                path: this.$route.query.redirect || '/',
              });
            },
            error: ({ data: { msg } }) => {
              this.error = getErrorMsg(msg, ERRORS);
            },
            complete: () => {
              this.loading = false;
            },
          })),
        ),
    };
  },
  mounted() {
    this.$emit('updated');
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/form--auth";
</style>

<style scoped lang="scss">
.form {
  &__remember {
    font-size: 14px;
    color: #636d77;

    &::v-deep .custom-control-label {
      &::before, &::after {
        top: 0.13rem;
      }
    }
  }

  &__forget-pw {
    color: #1a73e8;
    font-weight: 400;
    font-size: 0.875rem;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
